import { HttpContextToken } from '@angular/common/http';

export const SkipByAuthInterceptor = new HttpContextToken(() => true);
